"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesView = void 0;
const CompaniesView_yaml_component_1 = __importDefault(require("./CompaniesView.yaml?component"));
exports.CompaniesView = CompaniesView_yaml_component_1.default;
